export default () => ({

    set current(id) {
        this.current = id;
    },

    get current() {
        return this.current;
    },

    current: null,

    clicked: false,

    menu(clickOnly = false) {
        return {
            ['x-on:click.outside']() {
                this.current = -1;
                this.clicked = false;
            },
            ['x-on:mouseenter']() {
                if(this.current !== this.$el.id) {
                    this.clicked = false;
                }
                if(!clickOnly) {
                    this.current = this.$el.id;
                }
            },
            ['x-on:mouseleave']() {
                if(!this.clicked) {
                    this.current = -1;
                    this.clicked = false;
                }
            },
            ['x-on:click.stop']() {
                if(!this.clicked) {
                    this.current = this.$el.id;
                    this.clicked = true;
                }
            },
            ['x-bind:id']() {
                return this.$id('expandable-click');
            },
            ['x-bind:aria-expanded']() {
                return this.current === this.$el.id;
            },
            ['x-on:keydown.escape']() {
                this.current = -1;
                this.clicked = false;
            },
            async ['x-on:keydown.tab']() {
                await this.$nextTick();
                if(!(this.$el.contains(document.activeElement))) {
                        this.current = -1;
                        this.clicked = false;
                }
            },
        };
    },
})